import * as React from 'react';

import Widget from './Widget';
import StateWidgetContainer from '../../StateWidgetContainer';

interface IWidgetData {
    nodes,
    states,
}

interface IProps {
    widgetId: string,
}

export default class WidgetContainer extends React.Component<IProps, void> {
    static propTypes = {
        widgetId: React.PropTypes.string.isRequired,
    };

    render() {
        return (
            <StateWidgetContainer {...this.props} widget={Widget} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widget/alerts/listAlertSummary/WidgetContainer.tsx